import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import NProgress from 'nprogress'
import Router from 'next/router'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import * as actions from '../../actions'
import Header from './Header'
import SpecialTopNav from '../landing/TopNav'
import AmbassadorTopNav from '../ambassadors/nav/AmbassadorTopNav'
import AmbassadorSideNav from '../ambassadors/nav/AmbassadorSideNav'
import AuthModal from '../auth/AuthModal'
import LocalNotification from '../shared/LocalNotification'
import Footer from '../landing/Footer'
import FooterMobile from '../landing/FooterMobile'
import Auth from '../../lib/Auth'

Router.events.on('routeChangeStart', () => NProgress.start())
Router.events.on('routeChangeComplete', () => NProgress.done())
Router.events.on('routeChangeError', () => NProgress.done())

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
function Layout({ children, meta, specialPage, isAmbassador, preloadImages }) {
  const appInitialised = useSelector((state) => state.appInitialised)
  const token = useSelector((state) => state.auth.token)
  const country = useSelector((state) => state.country)
  const viewer = useSelector((state) => state.users.all[state.users.viewer._id])
  const localNotification = useSelector((state) => state.localNotification)
  const isAuthModalActive = useSelector(
    (state) => state.auth.status.modalActive
  )
  const client = useLDClient()
  const dispatch = useDispatch()

  const initialiseApp = () => {
    dispatch({ type: actions.APP_INITIALISED })
  }

  const getOrFetchUserIPInfo = () => {
    dispatch(actions.location.getOrFetchUserIPInfo())
  }
  useEffect(() => {
    if (!appInitialised) {
      const value = Auth.getUserSearch() || country
      dispatch({ type: actions.CHANGE_COUNTRY, value })
      checkLocalStorageForToken()
      initialiseApp()
      getOrFetchUserIPInfo()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (client) {
      if (viewer?._id) {
        client.identify({ key: viewer._id })
      } else {
        client.identify({
          key: 'anonymous',
          anonymous: true
        })
      }
    }
  }, [viewer?._id, client])

  // @TODO: remove this after authentication is polished for web
  const checkLocalStorageForToken = async () => {
    if (window) {
      const localToken = Auth.getApiToken()
      const localUsername = Auth.getUsername()
      if (!token && !!localToken && !!localUsername) {
        dispatch({ type: actions.HANDLE_TOKEN, token: localToken })
        axios.defaults.headers.common.Authorization = `bearer ${localToken}`
        dispatch(actions.users.fetchViewer(localUsername))
      }
    }
  }

  return (
    <div style={{ width: '100%' }}>
      <Header preloadImages={preloadImages} meta={meta} />
      {localNotification && (
        <LocalNotification localNotification={localNotification} />
      )}
      {
        // eslint-disable-next-line no-nested-ternary
        specialPage ? (
          <SpecialTopNav /> // eslint-disable-next-line no-nested-ternary
        ) : isAmbassador ? (
          <AmbassadorTopNav />
        ) : (
          <></>
        )
      }
      <Top
        notifActive={!!localNotification}
        specialPage={specialPage}
        isAmbassador={isAmbassador}
      >
        {isAmbassador && <AmbassadorSideNav />}
        {children}

        {isAuthModalActive && <AuthModal />}
      </Top>

      <Footer />
      <FooterMobile />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  token: PropTypes.string,
  country: PropTypes.string.isRequired,
  viewer: PropTypes.objectOf(PropTypes.any),
  specialPage: PropTypes.bool,
  isAmbassador: PropTypes.bool,
  preloadImages: PropTypes.arrayOf(PropTypes.string)
}

Layout.defaultProps = {
  viewer: {},
  country: 'The World',
  token: '',
  specialPage: false,
  isAmbassador: false
}
export default Layout

const Top = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(
    100vh -
      ${(props) =>
        // TODO fix
        // eslint-disable-next-line no-nested-ternary
        props.specialPage
          ? '0px'
          : // TODO fix
          // eslint-disable-next-line no-nested-ternary
          props.notifActive
          ? '80px'
          : props.isAmbassador
          ? '64px'
          : '40px'}
  );
  margin-top: ${
    // eslint-disable-next-line sonarjs/cognitive-complexity
    (props) =>
      // eslint-disable-next-line no-nested-ternary
      props.specialPage
        ? '0px'
        : // eslint-disable-next-line no-nested-ternary
        props.notifActive
        ? '80px'
        : // eslint-disable-next-line no-nested-ternary
        props.isAmbassador
        ? '0px'
        : '64px'
  };
  display: flex;
  flex-direction: ${(props) => (props.isAmbassador ? 'row' : 'column')};
  @media (min-width: 701px) {
    margin-top: ${(props) =>
      // TODO fix
      // eslint-disable-next-line no-nested-ternary
      props.specialPage
        ? '0px'
        : // TODO fix
        // eslint-disable-next-line no-nested-ternary
        props.notifActive
        ? '112px'
        : props.isAmbassador
        ? '0px'
        : '64px'};
    min-height: calc(
      100vh -
        ${(props) =>
          // TODO fix
          // eslint-disable-next-line no-nested-ternary
          props.specialPage
            ? '0px'
            : // TODO fix
            // eslint-disable-next-line no-nested-ternary
            props.notifActive
            ? '136px'
            : props.isAmbassador
            ? '64px'
            : '96px'}
    );
  }
`
